import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default class TicketSupportPage extends React.Component {
  componentDidMount() {
    this.messageHandler = (event) => {
      if (!event.data || event.data.source !== "ticket_support") return;
      const { type, payload } = event.data;
      if (type === "onUpdateTickets" && this.props.onUpdateTickets) {
        this.props.onUpdateTickets(payload);
      }
    };
    window.addEventListener("message", this.messageHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.messageHandler);
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.close}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle sx={{ position: "relative" }}>
          Ticket support
          <IconButton
            onClick={this.props.close}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0, height: "85vh", overflow: "hidden", "&.MuiDialogContent-root": { paddingTop: 0 } }}>
          <iframe
            src="/ticket_support/"
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Ticket support"
          />
        </DialogContent>
      </Dialog>
    );
  }
}
